import { AuthState, isIndeterminateAuthState } from "util/useAuth/types";
import getDailyLives from "./getDailyLives";
import getDailyLivesRemaining from "./getDailyLivesRemaining";

export default function getDailyLivesUsed(auth: AuthState) {
  if (isIndeterminateAuthState(auth)) {
    return 0;
  }

  return getDailyLives(auth) - getDailyLivesRemaining(auth);
}
